import React, { useEffect, useState } from "react";
import CardTask from "../../components/Card/CardTask";
import { Link, useHistory, useLocation } from "react-router-dom";
import TaskModal from "./TaskModal";
import SearchBar from "../../components/Searchbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import ButtonBlue from "../../components/Button/ButtonBlue";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import { getLearningTask } from "../../redux/actions/learning";
import { IoFilterOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
// import { Card } from "reactstrap";
import {
  Card,
  SideBarActiveCount,
  SideBarActiveDiv,
  SideBarActiveDivButton,
  SideBarActiveDivButtonNew,
  SideBarActiveDivNew,
  SideBarNormalCount,
  SideBarNormalDiv,
  SideBarNormalDivButton,
  SideBarNormalDivButtonNew,
  SideBarNormalDivNew,
} from "../Theme";
import { GET_THEME_LOADER } from "../../redux/actions/auth";

export default function DPTask() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const taskList = useSelector((state) => state.learning.taskList);

  const [newAssignments, setNewAssignments] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [pinnedAssignments, setPinnedAssignments] = useState([]);
  const [searchField, setSearchField] = useState("");
  const [nonPinnedAssignment, setNonPinnedAssignment] = useState([]);
  const [searchedTask, setSearchedTask] = useState([]);
  const [task, setTask] = useState({});
  const [title, setTitle] = useState("");
  const [taskModal, setTaskModal] = useState(false);
  const [couOptions, setCouOptions] = useState([]);

  const [selectedCourse, setSelectedCourse] = useState("-1");
  const [selectedStatus, setSelectedStatus] = useState("-2");
  const [selectedPinOption, setSelectedPinOption] = useState("-1");

  const [show, setShow] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [pinnedShow, setpinnedShow] = useState(true);
  const [pinnedSidebar, setpinnedSidebar] = useState(false);
  const [groupShow, setgroupShow] = useState(true);
  const [groupSidebar, setgroupSidebar] = useState(false);

  const [completedTask, setcompletedTask] = useState(null);
  const [progressTask, setprogressTask] = useState(null);
  const [newTask, setnewTask] = useState(null);
  const [modal, setModal] = useState(false);
  const [clear, setClear] = useState(false);

  const [pinnedAssignmentsSidebar, setpinnedAssignmentsSidebar] = useState([]);

  const status = [
    { id: 1, status: "New", total: newTask },
    { id: 2, status: "In Progress", total: progressTask },
    { id: 3, status: "Completed", total: completedTask },
  ];

  // useEffect(() => {
  //   setNewAssignments(taskList.filter(item => item.seen_status === false))
  //   setAssignments(taskList.filter(item => item.seen_status !== true))
  // }, [taskList])

  const showSidebar = () => {
    setShow(!show);
    setSidebar(!sidebar);
    setSelectedStatus("-1");
  };
  const showPinnedSidebar = () => {
    setpinnedShow(!pinnedShow);
    setpinnedSidebar(!pinnedSidebar);
    setSelectedPinOption("");
  };
  const showGroupSidebar = () => {
    setgroupShow(!groupShow);
    setgroupSidebar(!groupSidebar);
    setSelectedCourse("-1");
  };

  useEffect(() => {
    setcompletedTask(
      taskList.filter(
        (task) => task.task_done === task.task_count && task.task_count > 0
      ).length
    );
    setprogressTask(
      taskList.filter(
        (task) => task.task_done < task.task_count && task.seen_status === true
      ).length
    );
    setnewTask(
      taskList.filter(
        (item) => item.seen_status === false || item.task_count === 0
      ).length
    );
    var pinnedData = taskList.filter((item) => item.pin_status === true);
    var result = pinnedData.reduce((unique, o) => {
      if (!unique.some((obj) => obj.group_id === o.group_id)) {
        unique.push(o);
      }
      return unique;
    }, []);
    result.forEach((data) => {
      data["pinCount"] = pinnedData.filter(
        (val) => data.group_id === val.group_id
      ).length;
    });
    result.sort((a, b) => a.group_name.localeCompare(b.group_name));
    setpinnedAssignmentsSidebar(result);
  }, [taskList]);

  useEffect(() => {
    // Course filter
    let selectedTask = taskList.filter((task) =>
      selectedCourse === "-1" ? true : task.group_name === selectedCourse
    );
    // Status filter
    if (selectedStatus === "-1" || selectedStatus === "-2") {
      selectedTask = selectedTask.filter((task) => true);
    } else if (selectedStatus === "1") {
      selectedTask = selectedTask.filter(
        (item) => item.seen_status === false || item.task_count === 0
      );
    } else if (selectedStatus === "2") {
      selectedTask = selectedTask.filter(
        (task) =>
          task.task_done < task.task_count &&
          task.task_count !== 0 &&
          task.seen_status === true
      );
    } else {
      selectedTask = selectedTask.filter(
        (task) => task.task_done === task.task_count && task.task_count > 0
      );
    }
    // if (selectedCourse === "-1") {
    //   setcompletedTask(
    //     taskList.filter(
    //       (task) => task.task_done === task.task_count && task.task_count > 0
    //     ).length
    //   );
    //   setprogressTask(
    //     taskList.filter(
    //       (task) =>
    //         task.task_done < task.task_count && task.seen_status === true
    //     ).length
    //   );
    //   setnewTask(
    //     taskList.filter(
    //       (item) => item.seen_status === false || item.task_count === 0
    //     ).length
    //   );
    // } else {
    //   setcompletedTask(
    //     taskList.filter(
    //       (task) =>
    //         task.task_done === task.task_count &&
    //         task.task_count > 0 &&
    //         task.group_name === selectedCourse
    //     ).length
    //   );
    //   setprogressTask(
    //     taskList.filter(
    //       (task) =>
    //         task.task_done < task.task_count &&
    //         task.group_name === selectedCourse &&
    //         task.seen_status === true
    //     ).length
    //   );
    //   setnewTask(
    //     taskList.filter(
    //       (item) =>
    //         (item.seen_status === false || item.task_count === 0) &&
    //         item.group_name === selectedCourse
    //     ).length
    //   );
    // }

    setSearchedTask(filterBy(selectedTask));

    //pinned
    if (selectedPinOption === "-1") {
      var pinnedData = selectedTask.filter((item) => item.pin_status === true);
      setPinnedAssignments(pinnedData);

      var result = pinnedData.reduce((unique, o) => {
        if (!unique.some((obj) => obj.group_id === o.group_id)) {
          unique.push(o);
        }
        return unique;
      }, []);
      result.forEach((data) => {
        data["pinCount"] = pinnedData.filter(
          (val) => data.group_id === val.group_id
        ).length;
      });
      result.sort((a, b) => a.group_name.localeCompare(b.group_name));
      // setpinnedAssignmentsSidebar(result);

      setNewAssignments(
        selectedTask.filter(
          (item) =>
            (item.pin_status === false &&
              item.seen_status === false &&
              item.task_count !== 0) ||
            (item.pin_status === false && item.task_count === 0)
        )
      );
      setNonPinnedAssignment(
        selectedTask.filter(
          (item) =>
            item.pin_status === false &&
            item.seen_status === true &&
            item.task_count !== 0
        )
      );
    } else if (selectedPinOption === "") {
      var pinnedData = selectedTask.filter((item) => item.pin_status === true);

      setPinnedAssignments(pinnedData);

      var result = pinnedData.reduce((unique, o) => {
        if (!unique.some((obj) => obj.group_id === o.group_id)) {
          unique.push(o);
        }
        return unique;
      }, []);
      result.forEach((data) => {
        data["pinCount"] = pinnedData.filter(
          (val) => data.group_id === val.group_id
        ).length;
      });
      result.sort((a, b) => a.group_name.localeCompare(b.group_name));
      // setpinnedAssignmentsSidebar(result);

      setNewAssignments([]);
      setNonPinnedAssignment([]);
    } else {
      var pinnedData = selectedTask.filter((item) => item.pin_status === true);
      setPinnedAssignments(
        selectedTask.filter(
          (item) =>
            item.pin_status === true && selectedPinOption === item.group_name
        )
      );

      var result = pinnedData.reduce((unique, o) => {
        if (!unique.some((obj) => obj.group_id === o.group_id)) {
          unique.push(o);
        }
        return unique;
      }, []);
      result.forEach((data) => {
        data["pinCount"] = pinnedData.filter(
          (val) => data.group_id === val.group_id
        ).length;
      });
      result.sort((a, b) => a.group_name.localeCompare(b.group_name));
      // setpinnedAssignmentsSidebar(result);

      setNewAssignments([]);
      setNonPinnedAssignment([]);
    }
  }, [
    selectedCourse,
    taskList,
    searchField,
    selectedStatus,
    selectedPinOption,
  ]);

  // useEffect(() => {
  //   setSelectedPinOption("-1");
  // }, [selectedCourse, selectedStatus]);

  useEffect(() => {
    if (setSelectedStatus === "-2") {
      setSelectedStatus("-1");
    }
  }, [selectedPinOption, selectedCourse]);

  function filterBy(oldArray) {
    if (searchField.length === 0) {
      return oldArray;
    } else {
      oldArray.forEach((data) => {
        if (data.group_name === null) {
          data.group_name = "";
        }
        if (data.list_name === null) {
          data.list_name = "";
        }
      });
      let newArray = oldArray.filter(
        (taskList) =>
          taskList?.list_name
            .toString()
            .toLowerCase()
            .includes(searchField.toLowerCase()) ||
          taskList?.group_name
            .toString()
            .toLowerCase()
            .includes(searchField.toLowerCase())
      );
      return newArray;
    }
  }

  useEffect(() => {
    axios.get(serverUrl.LearningCourses).then((res) => {
      if (res.status === 200) {
        const newOptions = res.data.map((item) => ({
          label: item.group_name,
          value: item.group_id,
        }));

        setCouOptions(newOptions);
      }
    });

    dispatch(getLearningTask());
  }, []);

  const closeModal = () => setTaskModal(false);
  const openModal = (title, task) => {
    setTaskModal(true);
    setTask(task);
    setTitle(title);
  };

  const handleSeen = (task) => {
    if (task.seen_status === false) {
      axios.post(serverUrl.Learning + `/seen/${task.id}`).then((res) => {
        dispatch(getLearningTask());
      });
    }
  };
  // const handleReset=()=>{
  //    setSelectedCourse("-1");
  //    setSelectedStatus("-1");
  //    setSelectedPinOption("-1");
  //    setSearchField("");
  //    setClear(true);
  // }
  const Tab = ({ text, active, ...props }) => {
    let style = "font-14px font-medium cursor-pointer hover:text-blue-500";
    return active ? (
      <SideBarActiveDiv className={style}>{text}</SideBarActiveDiv>
    ) : (
      <SideBarNormalDiv className={style}>{text}</SideBarNormalDiv>
    );
  };

  return (
    <div className="flex flex-col md:flex-col lg:flex-row ">
      <div className="flex flex-row-reverse lg:flex-col border-right-f1">
        <div className="px-4 w-full border-bottom-f1 pt-4 pb-3 md:pt-6 md:pb-6 box-border">
          <SearchBar setSearchField={setSearchField} />
        </div>
        <div className="lg:w-64 md:top-32 flex flex-row lg:flex-col-reverse">
          <div className="lg:hidden border-bottom-f1 flex items-center">
            <div className="bg-white flex items-center h-12 pl-10 pr-4 mr-4">
              <IoFilterOutline
                className="w-6 h-6 cursor-pointer"
                onClick={() => setModal(true)}
              />
            </div>
          </div>
          <Card
            className={
              modal
                ? `inline-block lg:bg-white lg:bg-opacity-100 
                                 lg:mt-0 bg-black bg-opacity-60 w-full h-[calc(100vh-88px)]  
                                overflow-auto lg:pr-20 fixed topbar-offset lg:relative z-50 pr-16 `
                : `hidden lg:inline-block lg:bg-opacity-100 
                                mt-20 lg:mt-0 lg:rounded-lg 
                                 fixed top-0 lg:relative z-10 pb-6`
            }
            // style={{ height: "100%" }}
          >
            <>
              <div
                className="flex pt-5 pb-3 pl-2 lg:pt-0 lg:mt-3  pr-2 items-center cursor-pointer border-bottom-f1"
                onClick={() => {
                  setSelectedStatus("-2");
                  setSelectedCourse("-1");
                  setSelectedPinOption("-1");
                }}
              >
                {selectedStatus === "-2" &&
                selectedCourse == "-1" &&
                selectedPinOption == "-1" ? (
                  <SideBarActiveDivNew
                    className={`font-14px font-bold cursor-pointer w-full py-1 pl-2 `}
                  >
                    All tasks
                  </SideBarActiveDivNew>
                ) : (
                  <SideBarNormalDivNew
                    className={`font-14px font-bold cursor-pointer w-full py-1 pl-2 `}
                  >
                    All tasks
                  </SideBarNormalDivNew>
                )}
              </div>

              <div className="w-full px-4">
                <div className={` border-bottom-f1 pb-3 pt-3`}>
                  <div
                    className="flex  items-center justify-between cursor-pointer"
                    onClick={() => {
                      setShow(!show);
                    }}
                  >
                    <Tab
                      text="Status"
                      active={status.some(
                        (item1) => item1.id.toString() === selectedStatus
                      )}
                    />
                    {!show ? (
                      <MdKeyboardArrowDown className="blueColor" size={20} />
                    ) : (
                      <MdKeyboardArrowRight className="blueColor" size={20} />
                    )}
                  </div>
                  <div
                    className={
                      show
                        ? "hidden"
                        : "flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2"
                    }
                  >
                    {status.map((data, index) =>
                      selectedStatus === data.id.toString() ? (
                        <SideBarActiveDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                          key={index}
                          value={data.id.toString()}
                          onClick={(e) => {
                            setSelectedCourse("-1");
                            setSelectedPinOption("-1");
                            setSelectedStatus(data.id.toString());
                          }}
                        >
                          {data.status}{" "}
                          <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                            {data.total}
                          </SideBarActiveCount>
                        </SideBarActiveDivButtonNew>
                      ) : (
                        <SideBarNormalDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium`}
                          key={index}
                          value={data.id.toString()}
                          onClick={(e) => {
                            setSelectedCourse("-1");
                            setSelectedPinOption("-1");
                            setSelectedStatus(data.id.toString());
                          }}
                        >
                          {data.status}{" "}
                          <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                            {data.total}
                          </SideBarNormalCount>
                        </SideBarNormalDivButtonNew>
                      )
                    )}
                  </div>
                </div>
              </div>

              <div className="w-full px-4">
                <div className={` border-bottom-f1 pb-3 pt-3`}>
                  <div
                    className="flex  items-center justify-between cursor-pointer"
                    onClick={() => {
                      setpinnedShow(!pinnedShow);
                    }}
                  >
                    <Tab
                      text="Pinned"
                      active={pinnedAssignmentsSidebar.some(
                        (item1) => item1.group_name === selectedPinOption
                      )}
                    />
                    {!pinnedShow ? (
                      <MdKeyboardArrowDown className="blueColor" size={20} />
                    ) : (
                      <MdKeyboardArrowRight className="blueColor" size={20} />
                    )}
                  </div>
                  <div
                    className={
                      pinnedShow
                        ? "hidden"
                        : "flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2"
                    }
                  >
                    {pinnedAssignmentsSidebar.length > 0 ? (
                      pinnedAssignmentsSidebar.map((data, index) =>
                        selectedPinOption === data.group_name ? (
                          <SideBarActiveDivButtonNew
                            type="button"
                            className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                            key={index}
                            value={data.group_name}
                            onClick={(e) => {
                              setSelectedStatus("-2");
                              setSelectedCourse("-1");
                              setSelectedPinOption(data.group_name);
                            }}
                          >
                            {data.group_name}{" "}
                            <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                              {data.pinCount}
                            </SideBarActiveCount>
                          </SideBarActiveDivButtonNew>
                        ) : (
                          <SideBarNormalDivButtonNew
                            type="button"
                            className={`font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium`}
                            key={index}
                            value={data.group_name}
                            onClick={(e) => {
                              setSelectedStatus("-2");
                              setSelectedCourse("-1");
                              setSelectedPinOption(data.group_name);
                            }}
                          >
                            {data.group_name}{" "}
                            <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                              {data.pinCount}
                            </SideBarNormalCount>
                          </SideBarNormalDivButtonNew>
                        )
                      )
                    ) : (
                      <span className="flex items-center py-2 text-sm greyColor">
                        No Items
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-full px-4">
                <div className={`  pb-3 pt-3`}>
                  <div
                    className="flex  items-center justify-between cursor-pointer"
                    onClick={() => {
                      setgroupShow(!groupShow);
                    }}
                  >
                    <Tab
                      text="Groups"
                      active={couOptions.some(
                        (item1) => item1.label === selectedCourse
                      )}
                    />
                    {!groupShow ? (
                      <MdKeyboardArrowDown className="blueColor" size={20} />
                    ) : (
                      <MdKeyboardArrowRight className="blueColor" size={20} />
                    )}
                  </div>
                  <div
                    className={
                      groupShow
                        ? "hidden"
                        : "flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2"
                    }
                  >
                    {couOptions.filter(
                      (data) =>
                        taskList.filter(
                          (task) => task.group_name === data.label
                        ).length !== 0
                    ).length > 0 ? (
                      couOptions.map(
                        (data, index) =>
                          taskList.filter(
                            (task) => task.group_name === data.label
                          ).length !== 0 &&
                          (selectedCourse === data.label ? (
                            <SideBarActiveDivButtonNew
                              type="button"
                              className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                              key={index}
                              value={data.label}
                              onClick={(e) => {
                                setSelectedStatus("-2");
                                setSelectedPinOption("-1");
                                setSelectedCourse(data.label);
                              }}
                            >
                              {data.label}{" "}
                              <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                                {
                                  taskList.filter(
                                    (task) => task.group_name === data.label
                                  ).length
                                }
                              </SideBarActiveCount>
                            </SideBarActiveDivButtonNew>
                          ) : (
                            <SideBarNormalDivButtonNew
                              type="button"
                              className={`font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium`}
                              key={index}
                              value={data.label}
                              onClick={(e) => {
                                setSelectedStatus("-2");
                                setSelectedPinOption("-1");
                                setSelectedCourse(data.label);
                              }}
                            >
                              {data.label}{" "}
                              <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                                {
                                  taskList.filter(
                                    (task) => task.group_name === data.label
                                  ).length
                                }
                              </SideBarNormalCount>
                            </SideBarNormalDivButtonNew>
                          ))
                      )
                    ) : (
                      <span className="flex items-center py-2 text-sm greyColor">
                        No Items
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="absolute top-5 right-10 lg:hidden text-gray-400 cursor-pointer"
                onClick={() => setModal(false)}
              >
                <IoCloseOutline className="w-8 h-8" />
              </div>
            </>
          </Card>
        </div>
      </div>

      <div className=" w-full backGroundColor border20pxbottomright lg:rounded-bl-none rounded-bl-2xl ">
        <TaskModal
          onClose={closeModal}
          show={taskModal}
          title={title}
          task={task}
        />

        <div className="pt-3 pb-5 md:pb-8 flex flex-col-reverse md:flex-row justify-between hidden">
          <div className="flex flex-row md:self-center mt-5 md:mt-0">
            {/* Courses Dropdown */}
            <select
              className="rounded-full w-24 md:w-32 xl:w-44 h-8 md:h-10 mr-1 md:mr-4 pl-3 cursor-pointer justify-between
                          bg-white border border-gray-300 flex items-center text-gray-500 cursor-pointer"
              type="text"
              value={selectedCourse}
              onChange={(e) => setSelectedCourse(e.target.value)}
            >
              <option value="-1">All Courses</option>
              {couOptions &&
                couOptions.map((option, index) => (
                  <option key={index} value={option.label}>
                    {option.label}
                  </option>
                ))}
            </select>

            {/* Status Dropdown */}
            <select
              className="rounded-full w-24 md:w-32 xl:w-44 h-8 md:h-10 md:mr-4 pl-3 cursor-pointer justify-between
                          bg-white border border-gray-300 flex items-center text-gray-500 cursor-pointer"
              type="text"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="-1" selected>
                All Status
              </option>
              <option value="progress">In Progress</option>
              <option value="completed">Completed</option>
            </select>

            <p className="flex items-center text-sm md:text-md lg:text-base mx-3 md:mx-8 lg:mx-24 xl:mx-60 whitespace-nowrap">
              Showing{" "}
              {newAssignments.length +
                nonPinnedAssignment.length +
                pinnedAssignments.length}{" "}
              of {taskList.length} items
            </p>
          </div>
          {/* <div>
          <SearchBar setSearchField={setSearchField} />
        </div> */}
        </div>
        {/* Search result section */}
        {searchField.length > 0 && (
          <div>
            <div className="flex py-8 px-5 cardBackgroundColor">
              <span className="flex items-center gap-2 md:ml-1">
                Search result{" "}
                <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                  {searchedTask.length}
                </SideBarActiveCount>
              </span>
              <div className="border-t border-gray-500 w-auto" />
            </div>
            <div className="grid p-2 md:p-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5">
              {searchedTask.map((list, index) => (
                <Link
                  key={index}
                  className="hover:no-underline flex"
                  to={{
                    pathname: "/tasks/detail/" + list.id,
                    src: location.pathname,
                  }}
                >
                  <CardTask
                    key={index}
                    data={list}
                    openModal={() => openModal(list.list_name, list.tasks)}
                    isMyTask={false}
                  />
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Pinned assignment section */}
        {pinnedAssignments.length > 0 && searchField.length === 0 && (
          <div>
            <div className="flex py-8 px-5 cardBackgroundColor">
              <span className="flex items-center gap-2 md:ml-1">
                Pinned{" "}
                <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                  {pinnedAssignments.length}
                </SideBarActiveCount>
              </span>
              <div className="border-t border-gray-500 w-auto" />
            </div>
            <div className="grid grid-cols-1 p-2 md:p-5 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5">
              {pinnedAssignments.map((list, index) => (
                <Link
                  key={index}
                  className="hover:no-underline flex "
                  to={{
                    pathname: "/tasks/detail/" + list.id,
                    src: location.pathname,
                  }}
                >
                  <CardTask
                    key={index}
                    data={list}
                    openModal={() => openModal(list.list_name, list.tasks)}
                    isMyTask={false}
                  />
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* New assignment section */}
        {newAssignments.length > 0 && searchField.length === 0 && (
          <div>
            <div className="flex py-8 px-5 cardBackgroundColor">
              <span className="flex items-center gap-2 md:ml-1 ">
                New{" "}
                <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                  {newAssignments.length}
                </SideBarActiveCount>
              </span>
              <div className="border-t border-gray-500 w-auto" />
            </div>
            <div className="grid grid-cols-1 p-2 md:p-5 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5">
              {newAssignments.map((list, index) => (
                <Link
                  key={index}
                  className="hover:no-underline flex"
                  to={{
                    pathname: "/tasks/detail/" + list.id,
                    src: location.pathname,
                  }}
                  onClick={() => handleSeen(list)}
                >
                  <CardTask
                    key={index}
                    data={list}
                    openModal={() => openModal(list.list_name, list.tasks)}
                    isMyTask={false}
                  />
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Non pinned assignment section */}
        {nonPinnedAssignment.length > 0 && searchField.length === 0 && (
          <div>
            <div className="flex py-8 px-5 cardBackgroundColor">
              <span className="flex items-center gap-2 md:ml-1">
                Assignment{" "}
                <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                  {nonPinnedAssignment.length}
                </SideBarActiveCount>
              </span>
              <div className="border-t border-gray-500 w-auto" />
            </div>
            <div className="grid grid-cols-1 p-2 md:p-5 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5">
              {nonPinnedAssignment.map((list, index) => (
                <Link
                  key={index}
                  className="hover:no-underline flex"
                  to={{
                    pathname: "/tasks/detail/" + list.id,
                    src: location.pathname,
                  }}
                >
                  <CardTask
                    key={index}
                    data={list}
                    openModal={() => openModal(list.list_name, list.tasks)}
                    isMyTask={false}
                  />
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* {(newAssignments.length > 0 && 
        <div>
          <div className='flex mb-8'>
            <p>New Assignment ({newAssignments.length})</p>
            <div className='border-t border-gray-500 w-auto'/>
          </div>
          <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-7 mb-8'>
            {newAssignments.map((list,index) => (
              <Link key={index} 
                className="hover:no-underline"
                to={{
                pathname: '/tasks/detail' + list.id,
                state: {list}
              }} >
                <CardTask 
                  key={index}
                  data={list}
                  openModal={() => openModal(list.list_name, list.tasks)}
                  // onClick={() => { 
                  //     history.push({pathname:`/tasks/detail/`, state: list}) 
                  // }}
                />
              </Link>
            ))}
          </div> 
        </div>
      )} */}
      </div>
    </div>
  );
}
